<template>
  <div class="page_main">
    <div class="top_bg_box">
      <div class="top_bg">
        <p class="top_bg_num">- {{ cityName }}今日共有 <span>{{ count }} </span>位用户找店铺 -</p>
      </div>
    </div>

    <div class="info">
      <div class="h2">已为您筛选出6条找店信息</div>
      <div style="display: flex;flex-wrap: wrap;justify-content: center;">
        <div v-for="(item, index) in personList" :key="index" class="list">
          <div class="title">
            寻找{{ districtName || item.cityName }}、{{ acreage ? acreage + '平左右' : '' }}店铺做{{ trade }}
          </div>
          <div class="other_info">
            <span class="name">{{ item.personName }}</span>
            <span class="phone">{{ item.personPhone ? handlePhone(item.personPhone, true) : '' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="serve">
      <div class="h2">平台服务</div>
      <div class="serve_main">
        <div class="line_box line1">
          <div class="ad_item">
            <img src="../imgs/v2/pipei@2x.png">
            资源精准匹配
          </div>
          <div>
            <img src="../imgs/v2/genjin@2x.png">
            回访跟进意向找店用户
          </div>

        </div>
        <div class="line_box line2">
          <div class="ad_item">
            <img src="../imgs/v2/zaixiangoutong@2x.png">
            人工线上协助洽谈
          </div>
          <div>
            <img src="../imgs/v2/pingtai@2x.png">
            平台推广展示
          </div>
        </div>
        <div class="line_box line3">
          <div>
            <img src="../imgs/v2/shijiantongbu@2x.png">
            收集整理58、抖音、微信、百度等平台找店资源
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="pay_main">
        <div class="pay_left" @click="pay(1)">
          <img src="../imgs/v2/vip@2x.png">
          <span>开通服务  让客户来找您</span>
        </div>
        <div v-if="!loading" class="pay_right" @click="pay(1)">
          <span class="span1">￥</span>
          <span class="span2">198</span>
          <span class="span3">立即开通</span>
        </div>
        <div v-if="loading" class="loading_box">
          <van-loading color="#ffffff">支付中...</van-loading>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { citys, handlePhone, headers, RandomNumBoth } from '@/utils/util'
import { reSetCookie } from '@/utils/cookie'
import { wxConfig } from '@/utils/wx'
import { getPayResult, getTradeList, wxPay } from '@/api/api'
import {channelCode} from "@/utils/config";

export default {
  name: 'Pay2',
  data() {
    return {
      cityName: this.$store.getters.cityName,
      loading: false,
      tradeList: [],
      topToastText: this.$store.getters.config.topToastText,
      turnover: this.$store.getters.turnover,
      personList: this.$store.getters.personList,
      count: 0,
      payData: {
        redirectUrl: `${location.origin}/#/pay?pay=1`,
        feeType: 2, // 费用类型，1-推广，这里固定传1
        paymentType: 1, // 支付类型，1-微信，2-支付宝
        publishId: this.$store.getters.publishId // 发布id
      },
      districtName: '',
      acreage: '',
      trade: '',
      tradeListOther: ['适合各类行业', '休闲娱乐类', '生活服务类', '出租', '其他行业']
    }
  },
  computed: {
    time() {
      return RandomNumBoth(15, 20)
    }
  },
  // beforeRouteEnter(to, from, next) {
  //     next((vm) => {
  //         if (!vm.$store.getters.publishId) {
  //             vm.replaceRouter()
  //         }
  //     })
  // },
  created() {
    this.token = this.$store.getters.token
    this.init()
  },
  methods: {
    init() {
      this.getConfig()
      this.getTradeList()
      if (this.$store.getters.publishId) {
        // 查看回调
        this.getPayResult()
      }
      let count = 0
      const city = this.$store.getters.cityName
      if (citys.includes(city.slice(0, 2))) {
        count = RandomNumBoth(5000, 6000)
      } else {
        count = RandomNumBoth(1000, 2000)
      }
      this.count = count

      if (localStorage.getItem('formData')) {
        const formData = JSON.parse(localStorage.getItem('formData'))
        console.log(formData)
        this.districtName = formData.districtName
        this.acreage = formData.acreage ? Math.floor(formData.acreage / 10) * 10 : ''
        if (formData.trade) {
          if (this.tradeListOther.includes(formData.trade)) {
            this.trade = '生意'
          } else {
            this.trade = formData.trade
          }
        } else {
          this.trade = '生意'
        }
        console.log(formData.trade)
      }
    },
    async getTradeList() {
      const res = await getTradeList()
      this.tradeList = res.data
    },
    async getConfig() {
      const data = await this.$store.dispatch('setConfig')
      this.topToastText = data.topToastText
    },
    closeIt() {
      console.log(this.$store.getters)
      this.$router.push('/rent')
    },
    handlePhone(phone, isHide) {
      return handlePhone(phone, isHide)
    },
    replaceRouter() {
      this.$router.replace('/publish')
    },
    async getPayResult() {
      try {
        await getPayResult(
          headers({ publishId: this.$store.getters.publishId, channelCode }),
          { publishId: this.$store.getters.publishId, channelCode }
        )
        alert('平台已开始筛选匹配，请耐心等候，随时保持电话畅通')
        reSetCookie('publishId')
        this.$router.push('/rent')
      } catch {
        console.log(11)
      }
    },
    async pay(paymentType) {
      if (this.loading) {
        return
      }
      console.log('channelCode', channelCode)
      try {
        this.loading = true
        const res = await wxPay(
          headers({
            url: encodeURIComponent(location.href),
            feeType: 2,
            paymentType,
            channelCode,
            publishId: this.$store.getters.publishId
          }),
          {
            url: encodeURIComponent(location.href),
            feeType: 2,
            paymentType,
            channelCode,
            publishId: this.$store.getters.publishId
          }
        )
        const config = res.data
        switch (channelCode) {
          case 'ADAPAY_WX_PUB':
            console.log('支付 config', config)
            const wx = await wxConfig(config.configData)
            this.loading = false
            wx.chooseWXPay({
              timestamp: config.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: config.nonceStr, // 支付签名随机串，不长于 32 位
              package: config.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: config.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: config.paySign, // 支付签名
              success: function(res) {
                // 支付成功后的回调函数
                console.log(res)
              }
            })
            break;
          case 'JINGXIU_PAY':
            window.location.href = config.payUrl
            break;
          default:
            break;
        }
      } catch {
        this.loading = false
        console.log('支付失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page_main {
  background-color: #f2f2f2;
  min-height: calc(100vh - 80px);

  .top_bg_box {
    height: 70px;
  }

  .top_bg {
    height: 210px;
    background: #FF5C39;
    border-radius: 0px 0px 12px 12px;
    padding-top: 0px;
    box-sizing: border-box;

    .top_bg_num {
      text-align: center;
      font-size: 26px;
      color: #fff;
      font-family: Source Han Sans CN;
      font-weight: 400;

      span {
        font-size: 28px;
        color: #FFF600;
      }
    }
  }

  .info {
    width: 690px;
    margin: 0 auto 0;
    background: #FFFFFF;
    border-radius: 12px;
    position: relative;

    padding-top: 22px;
    padding-bottom: 30px;
    box-sizing: border-box;

    .h2 {
      font-size: 26px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #FF5C39;
      text-align: center;
      margin-bottom: 26px;
    }

    .list {
      margin-bottom: 38px;
      min-width: 60%;

      .title {
        height: 26px;
        font-size: 26px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        position: relative;
        padding-left: 28px;

        &:before {
          content: '';
          width: 15px;
          height: 15px;
          border-radius: 2px;
          background: #FF5C39;
          display: block;
          position: absolute;
          left: 0;
          top: 5px;
          transform: rotate(45deg);
        }
      }

      .other_info {
        font-size: 22px;
        color: #666666;
        margin-top: 16px;

        .name {
          background: url("../imgs/v2/user@2x.png") left center no-repeat;
          background-size: 30px 30px;
          padding-left: 30px;
          margin-right: 50px;
        }

        .phone {
          background: url("../imgs/v2/phone@2x.png") left center no-repeat;
          background-size: 28px 28px;
          padding-left: 30px;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .serve {
    width: 690px;
    height: 220px;
    background: #FFFFFF;
    border-radius: 6px;
    margin: 20px auto 0;
    overflow: hidden;
    padding-top: 12px;

    .h2 {
      font-size: 26px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #FF6030;
      text-align: center;
      margin-bottom: 8px;
    }

    .serve_main {
      padding-left: 60px;
      font-size: 26px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #E9734F;
      line-height: 36px;

      img {
        width: 36px;
        height: 36px;
      }

      .line_box {
        display: flex;
        margin-bottom: 16px;

        div {
          display: flex;
          align-items: center;
        }
      }

      .ad_item {
        width: 280px;
      }
    }
  }
}

.footer {
  width: 750px;
  height: 160px;
  background: #FFFFFF;
  border-radius: 12px 12px 0px 0px;
  overflow: hidden;
  position: fixed;
  left: 0;
  bottom: 0;

  .pay_main {
    width: 690px;
    height: 100px;
    background: url("../imgs/v2/zf_bg.png") center center no-repeat;
    -webkit-background-size: 690px 100px;
    background-size: 690px 100px;
    margin: 30px auto 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .pay_left {
      padding-left: 20px;
      display: flex;
      align-items: center;

      img {
        width: 59px;
        height: 51px;
      }

      span {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;
        margin-left: 10px;
      }
    }

    .pay_right {
      .span1 {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
      }

      .span2 {
        font-size: 40px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;
        margin-right: 30px;
      }

      .span3 {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;
        margin-right: 48px;
      }
    }

    .loading_box {
      margin-right: 60px;
    }
  }
}

/*@media (max-width: 375px) {*/
/*.footer{*/
/*.pay_main{*/
/*.pay_left{*/
/*span{*/
/*font-size: 20px;*/
/*}*/
/*}*/
/*.pay_right{*/
/*.span2{*/
/*font-size: 34px;*/
/*margin-right: 10px;*/
/*}*/
/*}*/
/*}*/
/*}*/
/*}*/
</style>
